var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{staticClass:"console"},[_c('div',{staticClass:"console-message"},[_vm._v(_vm._s(_vm.$store.state.message))]),_c('n-loading-bar',{attrs:{"loading":_vm.$store.state.loading}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }